export default "__VITE_ASSET__BCHZAXpj__"